import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { vibrantTheme } from "./common";

/* "Featured article" banner on airline/airport profile pages (imported SocialPulse stories). */
export default function FeaturedArticle({ entityType, entityId }) {
  const [a, setA] = useState(null);
  useEffect(() => {
    if (!entityId) return;
    api.get("/articles-imported/by-entity", { params: { type: entityType, id: entityId } })
      .then((r) => setA(r.data.items[0] || null)).catch(() => setA(null));
  }, [entityType, entityId]);

  if (!a) return null;
  const theme = vibrantTheme(`featured-${a.slug}`);

  return (
    <Link to={`/articles/${a.slug}`} data-testid="featured-article-card"
      className="group grid sm:grid-cols-[240px_1fr] items-stretch overflow-hidden mb-8 text-white hover:shadow-xl transition-shadow"
      style={{ backgroundColor: theme.bg }}>
      {a.feature_image
        ? <img src={a.feature_image} alt="" className="h-44 sm:h-full w-full object-cover" loading="lazy" />
        : <div className="hidden sm:flex items-center justify-center bg-black/20"><BookOpen className="w-12 h-12 opacity-60" /></div>}
      <div className="p-6 min-w-0 flex flex-col justify-center">
        <div className="text-xs font-mono uppercase tracking-widest flex items-center gap-1.5 text-white/85">
          <BookOpen className="w-4 h-4" /> Featured article · TravelerPulse Library
        </div>
        <div className="font-heading font-900 text-2xl sm:text-3xl mt-1.5 leading-tight">{a.title}</div>
        <p className="text-sm text-white/85 mt-2 line-clamp-2">{a.excerpt}</p>
        <span className="mt-3 text-sm font-700 inline-flex items-center gap-1.5 bg-white/15 group-hover:bg-white/25 transition-colors px-3.5 py-1.5 self-start">
          Read the full profile <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
}
